// import $ from "jquery";
import { Modal } from "bootstrap";
import Plyr from "plyr";

/**
 * Initialize Plyr.js video
 *
 * @param {HTMLElement} container - container where video must be
 * @param {Object} options - Plyr options
 */
function initPlyrVideo(container, options) {
  const player = new Plyr(container, options);

  // const plyrTapHandler = () => {
  const plyrWrapper = player.elements.wrapper, plyrContainer = player.elements.container;

  // Add custom Plyr listener
  if (!plyrContainer._clickListener) {
    plyrContainer._clickListener = e => {
      const targets = [plyrContainer, plyrWrapper];

      // Ignore 'click' tap if target elem. is not container or is not within video wrapper
      if (!targets.includes(e.target) && !plyrWrapper.contains(e.target)) {
        return;
      }

      if (player.touch) {
        player.togglePlay();
      }
    }

    plyrContainer.addEventListener('click', plyrContainer._clickListener);
  }
  // }

  return player;
};

export const init = () => {
  // Initialize cvery modal
  document.querySelectorAll(".modal").forEach(modal => {
    new Modal(modal);
  });

  // Initialize video (for now considered it is one on a page)
  if (!document.querySelector('.banner .modal')) return;

  const bannerModal = document.querySelector('.banner .modal');
  const videoBlock = bannerModal.querySelector('video');

  if (videoBlock) {
    let videoPlayer;

    if (typeof Plyr !== 'undefined' && videoBlock) {
      if (!(videoPlayer instanceof Plyr)) {
        videoPlayer = initPlyrVideo(videoBlock, {
          title: videoBlock.dataset.title,
          autoplay: true,
          // without 'play-large' control (.plyr--full-ui.plyr--video .plyr__control--overlaid)
          controls: ['play', 'progress', 'mute', 'volume', 'captions', 'fullscreen']
        });
      }
    }

    bannerModal.addEventListener("show.bs.modal", function() {
      videoPlayer.play();
    });
    bannerModal.addEventListener("hidden.bs.modal", function() {
      videoPlayer.stop();
    });
  }
};
